@if(followers$ | async; as followers){
  <div class="box">
    @for (user of followers; track user) {
      <div class="mt-1">
        <div class="card">
          <div class="card-header">
            {{ user.login | uppercase }}
          </div>
          <a href="{{ user.html_url }}" target="_blank">
            <img
              src="{{ user.avatar_url }}"
              class="img-fluid"
              alt="Responsive image"
              />
          </a>
        </div>
      </div>
    }
  </div>
}
